import { LaLogger, LoggerFactory, LogLevel } from "@weltn24/la-client-logging";

export const log: LaLogger = LoggerFactory("la-interactive-web", {
  logLevel: LogLevel.Error,
  forceLogAggregation: true,
  forceLogConsole: true,
});
